import { ClientCompany } from "../types/clientCompanies";

export type ClientCompanyFormValues = {
  name: string;
  registrationNumber: string;
  contactEmail: string;
  contactPhone: string;
  address: string;
};

const trimOptional = (value: string) => {
  const trimmedValue = value.trim();
  return trimmedValue.length > 0 ? trimmedValue : undefined;
};

export const toCreateClientCompanyPayload = (values: ClientCompanyFormValues) => ({
  name: values.name.trim(),
  registrationNumber: values.registrationNumber.trim(),
  contactEmail: trimOptional(values.contactEmail),
  contactPhone: trimOptional(values.contactPhone),
  address: trimOptional(values.address),
});

export const toUpdateClientCompanyPayload = (values: ClientCompanyFormValues) => ({
  name: values.name.trim(),
  registrationNumber: values.registrationNumber.trim(),
  contactEmail: trimOptional(values.contactEmail),
  contactPhone: trimOptional(values.contactPhone),
  address: trimOptional(values.address),
});

export const toClientCompanyFormValues = (
  company: ClientCompany,
): ClientCompanyFormValues => ({
  name: company.name,
  registrationNumber: company.registrationNumber,
  contactEmail: company.contactEmail ?? "",
  contactPhone: company.contactPhone ?? "",
  address: company.address ?? "",
});
